export const FORM = 'user_form';
export const IMAGE = 'image';
export const DELAY = 'delay';
export const TEXT = 'text';
export const LIST = 'list';
export const OTN = 'otn';
export const QUICK_QUESTION = 'quick_question';
export const ITEM = 'entry';
export const GALLERY = 'gallery';
export const VIDEO = 'video';
export const EMAIL = 'email';
export const NAVIGATE = 'go_to';
export const MAX_ALLOWED_QQ_TEXT_LENGTH = 2000;
export const MAX_ALLOWED_BTNS = 11;
export const MAX_ALLOWED_MENU_BTNS = 3;
export const MAX_ALLOWED_MENU_BTNS_FREE = 2;
export const MAX_ALLOWED_SUB_MENU_BTNS = 5;
export const MAX_ALLOWED_ITEMS = 4;
export const MAX_ALLOWED_WIDGET_ITEMS = {
  text: 3,
};
export const GIF = 'giphy';
export const ATTACHMENT = 'attachment';
export const AUDIO = 'audio';
export const TYPING = 'typing_on';
export const ATTRIBUTE = 'attribute';
export const TAGS = 'tag';
export const SEND_DATA = 'send_data';
export const OPT_IN = 'opt_in';
export const POWERED_BY_SORT_ORDER = 999;
export const MAX_TEXT_WIDGET_LENGTH = 540;
